const Home = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      {/* Header */}
      <div className="bg-black text-white text-center py-2 px-4 text-xs">
        <div className="container mx-auto">
          Frete grátis a partir de R$139,90
        </div>
      </div>
      
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-14 sm:h-16 md:h-20">
            <div className="flex items-center gap-2 sm:gap-4">
              <button className="flex items-center justify-center w-8 h-8 hover:text-[#d80005] transition-colors">
                <i className="ri-search-line text-lg"></i>
              </button>
              <a href="https://www.respeiteohomem.com.br/account" target="_self" className="hidden md:flex items-center justify-center w-8 h-8 hover:text-[#d80005] transition-colors">
                <i className="ri-user-line text-lg"></i>
              </a>
            </div>
            
            <div className="flex-1 flex justify-center px-4">
              <a href="https://www.respeiteohomem.com.br/" target="_self">
                <img 
                  alt="Respeite o Homem" 
                  className="h-7 sm:h-9 md:h-11 w-auto" 
                  src="https://www.respeiteohomem.com.br/cdn/shop/files/sem-nome-990-x-500-px-1.webp?v=1754161846"
                />
              </a>
            </div>
            
            <div className="flex items-center gap-2 sm:gap-4">
              <button className="flex items-center justify-center w-8 h-8 hover:text-[#d80005] transition-colors">
                <i className="ri-shopping-cart-line text-lg"></i>
              </button>
            </div>
          </div>
          
          <nav className="hidden lg:flex items-center justify-center gap-4 xl:gap-6 pb-3 border-t pt-3 text-sm">
            <a href="https://www.respeiteohomem.com.br/collections/todos-os-produtos" target="_self" className="hover:text-[#d80005] transition-colors whitespace-nowrap">Nossos Produtos</a>
            <a href="https://www.respeiteohomem.com.br/collections/tratamento-para-calvicie" target="_self" className="hover:text-[#d80005] transition-colors whitespace-nowrap">Tratamento para Calvície</a>
            <a href="https://www.respeiteohomem.com.br/collections/pos-tratamento-prevencao-para-calvicie" target="_self" className="hover:text-[#d80005] transition-colors whitespace-nowrap">Pós-tratamento/Prevenção</a>
            <a href="https://www.respeiteohomem.com.br/blogs/novidades" target="_self" className="hover:text-[#d80005] transition-colors whitespace-nowrap">Blog</a>
            <a href="https://www.respeiteohomem.com.br/pages/rastreio" target="_self" className="hover:text-[#d80005] transition-colors whitespace-nowrap">Rastreio</a>
            <a href="https://www.respeiteohomem.com.br/collections/ofertas-do-dia" target="_self" className="ml-auto bg-[#d80005] text-white px-4 py-2 rounded hover:bg-red-700 transition-colors whitespace-nowrap">Ofertas do dia com até 40% OFF</a>
          </nav>
        </div>
      </header>

      {/* Hero Section */}
      <div className="container mx-auto px-4 py-8 sm:py-12 md:py-16">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-xl sm:rounded-2xl shadow-lg p-6 sm:p-8 md:p-12 text-center">
            <div className="mb-6 sm:mb-8">
              <div className="w-16 h-16 sm:w-20 sm:h-20 bg-[#d80005] rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
                <i className="ri-heart-pulse-line text-3xl sm:text-4xl text-white"></i>
              </div>
              <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-slate-900 mb-3 sm:mb-4 leading-tight px-2">
                Diagnóstico Capilar Completo
              </h1>
              <p className="text-base sm:text-lg md:text-xl text-slate-600 mb-6 sm:mb-8 leading-relaxed max-w-2xl mx-auto px-2">
                Descubra o estado da sua saúde capilar e receba recomendações personalizadas de tratamento em poucos minutos
              </p>
              <a
                href="/quiz"
                className="inline-block px-8 sm:px-10 py-4 sm:py-5 bg-[#d80005] text-white rounded-lg sm:rounded-xl font-bold text-base sm:text-lg hover:bg-red-700 transition-all shadow-xl hover:shadow-2xl whitespace-nowrap"
              >
                Iniciar diagnóstico gratuito
              </a>
              <p className="text-slate-600 mt-4 sm:mt-6 text-xs sm:text-sm px-2">
                ✓ 100% gratuito  ✓ Resultado imediato  ✓ Recomendações personalizadas
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="container mx-auto px-4 py-8 sm:py-12">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center text-slate-900 mb-3 sm:mb-4 px-2">
            Como funciona o diagnóstico
          </h2>
          <p className="text-center text-slate-600 text-base sm:text-lg mb-8 sm:mb-12 max-w-2xl mx-auto px-4">
            Um processo simples e rápido para identificar seu tipo de calvície e condição do couro cabeludo
          </p>

          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 md:gap-8">
            <div className="bg-white text-center p-6 sm:p-8 rounded-xl sm:rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-14 h-14 sm:w-16 sm:h-16 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
                <i className="ri-questionnaire-line text-2xl sm:text-3xl text-[#d80005]"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-slate-900 mb-2 sm:mb-3">
                7 Perguntas Simples
              </h3>
              <p className="text-sm sm:text-base text-slate-600 leading-relaxed">
                Responda perguntas sobre seu cabelo e couro cabeludo de forma rápida e objetiva
              </p>
            </div>

            <div className="bg-white text-center p-6 sm:p-8 rounded-xl sm:rounded-2xl shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-14 h-14 sm:w-16 sm:h-16 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
                <i className="ri-brain-line text-2xl sm:text-3xl text-[#d80005]"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-slate-900 mb-2 sm:mb-3">
                Análise Inteligente
              </h3>
              <p className="text-sm sm:text-base text-slate-600 leading-relaxed">
                Nossa tecnologia analisa suas respostas e identifica o grau de calvície e condições do couro cabeludo
              </p>
            </div>

            <div className="bg-white text-center p-6 sm:p-8 rounded-xl sm:rounded-2xl shadow-lg hover:shadow-xl transition-shadow sm:col-span-2 md:col-span-1">
              <div className="w-14 h-14 sm:w-16 sm:h-16 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
                <i className="ri-medicine-bottle-line text-2xl sm:text-3xl text-[#d80005]"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-slate-900 mb-2 sm:mb-3">
                Tratamento Personalizado
              </h3>
              <p className="text-sm sm:text-base text-slate-600 leading-relaxed">
                Receba recomendações específicas de produtos e tratamentos para o seu caso
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Benefits Section */}
      <div className="container mx-auto px-4 py-8 sm:py-12">
        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-[#d80005] to-red-700 rounded-xl sm:rounded-2xl shadow-xl p-6 sm:p-8 md:p-12">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-6 sm:mb-8 text-center px-2">
              Por que fazer o diagnóstico?
            </h2>
            <div className="grid sm:grid-cols-2 gap-4 sm:gap-6">
              <div className="flex items-start text-left bg-white/10 backdrop-blur-sm rounded-lg sm:rounded-xl p-4 sm:p-6">
                <i className="ri-check-line text-xl sm:text-2xl text-white mr-3 sm:mr-4 mt-1 flex-shrink-0"></i>
                <div>
                  <h3 className="text-base sm:text-lg font-bold text-white mb-1 sm:mb-2">Identificação precisa</h3>
                  <p className="text-sm sm:text-base text-white/90">
                    Saiba exatamente em que estágio de calvície você está
                  </p>
                </div>
              </div>
              <div className="flex items-start text-left bg-white/10 backdrop-blur-sm rounded-lg sm:rounded-xl p-4 sm:p-6">
                <i className="ri-check-line text-xl sm:text-2xl text-white mr-3 sm:mr-4 mt-1 flex-shrink-0"></i>
                <div>
                  <h3 className="text-base sm:text-lg font-bold text-white mb-1 sm:mb-2">Tratamento adequado</h3>
                  <p className="text-sm sm:text-base text-white/90">
                    Receba recomendações específicas para o seu tipo de calvície
                  </p>
                </div>
              </div>
              <div className="flex items-start text-left bg-white/10 backdrop-blur-sm rounded-lg sm:rounded-xl p-4 sm:p-6">
                <i className="ri-check-line text-xl sm:text-2xl text-white mr-3 sm:mr-4 mt-1 flex-shrink-0"></i>
                <div>
                  <h3 className="text-base sm:text-lg font-bold text-white mb-1 sm:mb-2">Economia de tempo</h3>
                  <p className="text-sm sm:text-base text-white/90">
                    Evite tratamentos inadequados e economize tempo e dinheiro
                  </p>
                </div>
              </div>
              <div className="flex items-start text-left bg-white/10 backdrop-blur-sm rounded-lg sm:rounded-xl p-4 sm:p-6">
                <i className="ri-check-line text-xl sm:text-2xl text-white mr-3 sm:mr-4 mt-1 flex-shrink-0"></i>
                <div>
                  <h3 className="text-base sm:text-lg font-bold text-white mb-1 sm:mb-2">Acompanhamento</h3>
                  <p className="text-sm sm:text-base text-white/90">
                    Receba dicas e informações sobre saúde capilar por e-mail
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="container mx-auto px-4 py-8 sm:py-12 md:py-16">
        <div className="max-w-3xl mx-auto">
          <div className="bg-white rounded-xl sm:rounded-2xl shadow-lg p-6 sm:p-8 md:p-12 text-center">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-slate-900 mb-4 sm:mb-6 px-2">
              Pronto para descobrir seu diagnóstico?
            </h2>
            <p className="text-base sm:text-lg md:text-xl text-slate-600 mb-6 sm:mb-10 px-2">
              Leva apenas 2 minutos e você receberá um diagnóstico completo e personalizado
            </p>
            <a
              href="/quiz"
              className="inline-block px-10 sm:px-12 py-4 sm:py-5 bg-[#d80005] text-white rounded-lg sm:rounded-xl font-bold text-base sm:text-lg hover:bg-red-700 transition-all shadow-xl hover:shadow-2xl whitespace-nowrap"
            >
              Começar agora
            </a>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-white border-t">
        <div className="container mx-auto px-4 py-6 sm:py-8 md:py-12">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 mb-6 sm:mb-8">
            <div>
              <h3 className="font-bold text-sm sm:text-base md:text-lg mb-3 sm:mb-4">Sobre Nós</h3>
              <div className="text-xs sm:text-sm text-gray-600 space-y-2">
                <p>Central de atendimento</p>
                <p>
                  <a href="https://api.whatsapp.com/send?l=pt_br&phone=5511919555920&text=Olá" target="_self" className="font-bold hover:text-[#d80005]">
                    11 919555920
                  </a>
                </p>
                <p>
                  <a href="mailto:sac@respeiteohomem.com.br" className="font-bold hover:text-[#d80005] break-all">
                    sac@respeiteohomem.com.br
                  </a>
                </p>
                <p>
                  <a href="tel:1151945215" className="font-bold hover:text-[#d80005]">
                    (11) 5194-5215
                  </a>
                </p>
                <p>De segunda a sexta, das 9 as 19 horas.</p>
                <p className="text-xs">Avenida Paulista, 1636, Bela vista - São Paulo - SP</p>
                <div className="flex gap-3 sm:gap-4 pt-3 sm:pt-4">
                  <a href="https://www.facebook.com/respeiteohomem" target="_self" className="text-gray-600 hover:text-[#d80005] transition-colors">
                    <i className="ri-facebook-fill text-xl sm:text-2xl"></i>
                  </a>
                  <a href="https://www.instagram.com/respeiteohomem.com.br/" target="_self" className="text-gray-600 hover:text-[#d80005] transition-colors">
                    <i className="ri-instagram-line text-xl sm:text-2xl"></i>
                  </a>
                  <a href="https://www.tiktok.com/@respeite.o.homem" target="_self" className="text-gray-600 hover:text-[#d80005] transition-colors">
                    <i className="ri-tiktok-fill text-xl sm:text-2xl"></i>
                  </a>
                  <a href="https://www.youtube.com/@RespeiteOHomem" target="_self" className="text-gray-600 hover:text-[#d80005] transition-colors">
                    <i className="ri-youtube-fill text-xl sm:text-2xl"></i>
                  </a>
                </div>
              </div>
            </div>

            <div>
              <h3 className="font-bold text-sm sm:text-base md:text-lg mb-3 sm:mb-4">Menu</h3>
              <ul className="text-xs sm:text-sm text-gray-600 space-y-2">
                <li>
                  <a href="https://www.respeiteohomem.com.br/collections/todos-os-produtos" target="_self" className="hover:text-[#d80005] transition-colors">
                    Nossos Produtos
                  </a>
                </li>
                <li>
                  <a href="https://www.respeiteohomem.com.br/collections/tratamento-para-calvicie" target="_self" className="hover:text-[#d80005] transition-colors">
                    Tratamento para Calvície
                  </a>
                </li>
                <li>
                  <a href="https://www.respeiteohomem.com.br/collections/pos-tratamento-prevencao-para-calvicie" target="_self" className="hover:text-[#d80005] transition-colors">
                    Pós-tratamento/Prevenção
                  </a>
                </li>
                <li>
                  <a href="https://www.respeiteohomem.com.br/blogs/novidades" target="_self" className="hover:text-[#d80005] transition-colors">
                    Blog
                  </a>
                </li>
                <li>
                  <a href="https://www.respeiteohomem.com.br/pages/rastreio" target="_self" className="hover:text-[#d80005] transition-colors">
                    Rastreio
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="font-bold text-sm sm:text-base md:text-lg mb-3 sm:mb-4">Políticas</h3>
              <ul className="text-xs sm:text-sm text-gray-600 space-y-2">
                <li>
                  <a href="https://www.respeiteohomem.com.br/search" target="_self" className="hover:text-[#d80005] transition-colors">
                    Sobre a Respeite o Homem
                  </a>
                </li>
                <li>
                  <a href="https://www.respeiteohomem.com.br/pages/como-funciona-o-tratamento" target="_self" className="hover:text-[#d80005] transition-colors">
                    Como funciona o tratamento
                  </a>
                </li>
                <li>
                  <a href="https://www.respeiteohomem.com.br/pages/grau-de-calvicie" target="_self" className="hover:text-[#d80005] transition-colors">
                    Consulte seu grau de calvície
                  </a>
                </li>
                <li>
                  <a href="https://www.respeiteohomem.com.br/pages/feedback-clientes" target="_self" className="hover:text-[#d80005] transition-colors">
                    Feedback Clientes
                  </a>
                </li>
                <li>
                  <a href="https://www.respeiteohomem.com.br/pages/como-comprar" target="_self" className="hover:text-[#d80005] transition-colors">
                    Como comprar
                  </a>
                </li>
                <li>
                  <a href="https://www.respeiteohomem.com.br/pages/garantia-troca-e-devolucao" target="_self" className="hover:text-[#d80005] transition-colors">
                    Garantia, troca e devolução
                  </a>
                </li>
                <li>
                  <a href="https://www.respeiteohomem.com.br/pages/politica-de-privacidade" target="_self" className="hover:text-[#d80005] transition-colors">
                    Política de Privacidade
                  </a>
                </li>
                <li>
                  <a href="https://www.respeiteohomem.com.br/pages/perguntas-frequentes" target="_self" className="hover:text-[#d80005] transition-colors">
                    Perguntas Frequentes (FAQ)
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="font-bold text-sm sm:text-base md:text-lg mb-3 sm:mb-4">Receba nossas promoções</h3>
              <p className="text-xs sm:text-sm text-gray-600 mb-4">
                Inscreva-se para receber descontos exclusivos direto no seu <strong>e-mail!</strong>
              </p>
              <form className="flex gap-2">
                <input 
                  placeholder="Email" 
                  className="flex-1 px-3 py-2 text-xs sm:text-sm border border-gray-300 rounded focus:outline-none focus:border-[#d80005]" 
                  required 
                  type="email"
                />
                <button className="bg-[#d80005] text-white px-4 sm:px-6 py-2 rounded hover:bg-red-700 transition-colors whitespace-nowrap">
                  <i className="ri-send-plane-fill"></i>
                </button>
              </form>
            </div>
          </div>

          <div className="border-t pt-6 sm:pt-8">
            <div className="text-center text-xs sm:text-sm text-gray-600 mb-6">
              <p>
                © 2025, <a href="https://www.respeiteohomem.com.br/" target="_self" className="hover:text-[#d80005]">Respeite o Homem</a> Todos direitos reservados.
              </p>
              <p className="mt-1">CNPJ: 51.519.325/0001-16</p>
              <p className="mt-2 px-2">
                Oferta exclusiva neste site oficial, sujeita a variação. Evite comprar produtos mais baratos ou de outras lojas, para evitar golpes. Não nos responsabilizamos por problemas em compras fora deste site.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 text-center">
              <div>
                <h4 className="font-bold text-xs sm:text-sm mb-3">Formas de Pagamento</h4>
                <div className="flex flex-wrap justify-center gap-2 text-xs text-gray-600">
                  <span className="px-2 sm:px-3 py-1 bg-gray-100 rounded">Mastercard</span>
                  <span className="px-2 sm:px-3 py-1 bg-gray-100 rounded">Visa</span>
                  <span className="px-2 sm:px-3 py-1 bg-gray-100 rounded">Elo</span>
                  <span className="px-2 sm:px-3 py-1 bg-gray-100 rounded">Hipercard</span>
                  <span className="px-2 sm:px-3 py-1 bg-gray-100 rounded">Amex</span>
                  <span className="px-2 sm:px-3 py-1 bg-gray-100 rounded">Diners</span>
                  <span className="px-2 sm:px-3 py-1 bg-gray-100 rounded">Boleto</span>
                  <span className="px-2 sm:px-3 py-1 bg-gray-100 rounded">PIX</span>
                </div>
              </div>

              <div>
                <h4 className="font-bold text-xs sm:text-sm mb-3">Selos de Segurança</h4>
                <div className="flex flex-wrap justify-center gap-4">
                  <a href="https://transparencyreport.google.com/safe-browsing/search?url=www.respeiteohomem.com.br" target="_self" className="text-xs text-gray-600 hover:text-[#d80005]">
                    Google Safe Browsing
                  </a>
                  <a href="https://www.siteconfiavel.com.br/site/www.respeiteohomem.com.br" target="_self" className="text-xs text-gray-600 hover:text-[#d80005]">
                    Site Confiável
                  </a>
                </div>
              </div>

              <div>
                <h4 className="font-bold text-xs sm:text-sm mb-3">Formas de Envio</h4>
                <div className="flex flex-wrap justify-center gap-3 text-xs text-gray-600">
                  <span className="px-2 sm:px-3 py-1 bg-gray-100 rounded">Correios</span>
                  <span className="px-2 sm:px-3 py-1 bg-gray-100 rounded">Loggi</span>
                </div>
              </div>
            </div>

            <div className="text-center mt-6 sm:mt-8">
              <h4 className="font-bold text-xs sm:text-sm mb-3">Lojas Oficiais</h4>
              <div className="flex justify-center gap-4 text-xs text-gray-600">
                <a href="https://www.mercadolivre.com.br/pagina/homemrespeite20231103122309" target="_self" className="hover:text-[#d80005]">
                  Mercado Livre
                </a>
                <a href="https://shopee.com.br/shop/1109134649" target="_self" className="hover:text-[#d80005]">
                  Shopee
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Home;
